export default __webpack_public_path__ + "static/media/settings.e1606f21.svg";